import * as types from '../../lib/actionTypes.es6';

export const initialState = {
  users: [],
  usersHasNextPage: false,
  loader: false,
  error: null,
  registrationError: null,

  disabledUsers: [],
  disabledUsersHasNextPage: false,

  userAuthActivities: null,
  userAuthActivitiesLoader: false,
  userToViewAuthActivities: null,
  userAuthActivitiesSuccess: false,
  userAuthActivitiesError: null,

  usersAuthActivities: null,
  usersAuthActivitiesLoader: false,
  usersAuthActivitiesSuccess: false,
  usersAuthActivitiesError: null,


  userCreated: null,
  createUserLoader: false,
  createUserSuccess: false,

  partners: [],
  partnersErrors: null,

  roles: [],
  roles_errors: null,
  roles_loader: false,

  currentroles: [],
  current_roles_errors: null,
  current_roles_loader: false,

  currentPartners: [],
  current_partner_errors: null,
  current_partner_loader: false,

  updateRolesAndPartnersErrors: null,
  updateRolesAndPartnersInfo: null,

  resetPasswordSuccess: null,
  resetPasswordErrors: null,
  resetPasswordLoader: false,


  deleteUserErrors: null,
  deleteUserSuccess: null,
  user: null,
  hardDeleteUserSuccess: false,

  hardDeleteUserLoader: false,
  userToDelete: null,
  editUserSuccess: false,
  UserToEdit: null,

  disableUserLoader: false,
  disableUserSuccess: false,
  userToDisable: null,
  disableUserErrors: null,

  enableUserLoader: false,
  enableUserSuccess: false,
  userToEnable: null,
  enableUserErrors: null,

  agents: [],
  agentsLoader: false,
  agentsError: null,

};

export default function userAdminReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_USERS_REQUEST':
      return { ...state, error: null, loader: true, users: [] };

    case 'GET_USERS_SUCCESS':
      return { ...state, users: action.payload.users, usersHasNextPage: action.payload.hasNextPage, loader: false };

    case 'GET_USERS_FAIL':
      return { ...state, loader: false, error: action.payload };

    case 'GET_AGENTS_REQUEST':
      return { ...state, agentsLoader: true, agentsError: null };

    case 'GET_AGENTS_SUCCESS':
      return { ...state, agentsLoader: false, agents: action.payload };

    case 'GET_AGENTS_FAIL':
      return { ...state, agentsLoader: false, agentsError: action.payload };

    case 'CREATE_USERS_REQUEST':
      return { ...state, registrationError: null, createUserLoader: true, createUserSuccess: false };

    case 'CREATE_USERS_SUCCESS':
      return { ...state, createUserLoader: false, userCreated: action.payload, createUserSuccess: true };

    case 'CREATE_USERS_FAIL':
      return { ...state, registrationError: action.payload, createUserLoader: false, createUserSuccess: false };

    case 'RESET_USERS_SUCCESS':
      return { ...state, createUserSuccess: false };

    case 'SET_USER_TO_DELETE':
      return { ...state, userToDelete: action.payload };

    case 'RESET_USER_TO_DELETE':
      return { ...state, userToDelete: null };

    case types.SET_USER_TO_DISABLE:
      return { ...state, userToDisable: action.payload };

    case types.RESET_USER_TO_DISABLE:
      return { ...state, userToDisable: null, disableUserErrors: null, disableUserSuccess: false, disableUserLoader: false };

    case types.RESET_DISABLE_USER_ERROR:
      return { ...state, disableUserErrors: null, disableUserSuccess: false, disableUserLoader: false, userToDisable: null };

    case types.RESET_DISABLE_USER_SUCCESS:
      return { ...state, disableUserSuccess: false , userToDisable: null , disableUserLoader: false };
    
    case types.DISABLE_USER_REQUEST:
      return { ...state, disableUserLoader: true, disableUserErrors: null, disableUserSuccess: false };

    case types.DISABLE_USER_SUCCESS:
      return { ...state, disableUserLoader: false, disableUserSuccess: true };

    case types.ENABLE_USER_REQUEST:
      return { ...state, enableUserLoader: true, enableUserErrors: null, enableUserSuccess: false };

    case types.ENABLE_USER_SUCCESS:
      return { ...state, enableUserLoader: false, enableUserSuccess: true };

    case types.ENABLE_USER_FAILURE:
      return { ...state, enableUserLoader: false, enableUserErrors: action.payload };

    case types.SET_USER_TO_ENABLE:
      console.log("SET_USER_TO_ENABLE action.payload:", action.payload);
      return { ...state, userToEnable: action.payload };

    case types.RESET_USER_TO_ENABLE:
      return { ...state, userToEnable: null, enableUserErrors: null, enableUserSuccess: false, enableUserLoader: false };

    case types.RESET_ENABLE_USER_ERROR:
      return { ...state, enableUserErrors: null, enableUserSuccess: false, enableUserLoader: false, userToEnable: null };

    case types.RESET_ENABLE_USER_SUCCESS:
      return { ...state, enableUserSuccess: false , userToEnable: null , enableUserLoader: false };

    case 'GET_PARTNERS_REQUEST':
      return state;

    case 'GET_PARTNERS_SUCCESS':
      return { ...state, partners: action.payload };

    case 'GET_PARTNERS_FAIL':
      return { ...state, partnersErrors: action.payload };

    case 'GET_ROLES_REQUEST':
      return { ...state, roles_errors: null, roles_loader: true, roles: [] };

    case 'GET_ROLES_SUCCESS':
      return { ...state, roles: action.payload, roles_loader: false, roles_errors: null };

    case 'GET_ROLES_FAIL':
      return { ...state, roles_loader: false, roles_errors: action.payload };


    case types.GET_CURRENT_ROLES_REQUEST:
      return { ...state, current_roles_errors: null, current_roles_loader: true, currentroles: [] };

    case types.GET_CURRENT_ROLES_SUCCESS:
      return { ...state, currentroles: action.payload, current_roles_loader: false, current_roles_errors: null };

    case types.GET_CURRENT_ROLES_FAIL:
      return { ...state, current_roles_loader: false, current_roles_errors: action.payload };

    case types.GET_CURRENT_PARTNER_REQUEST:
      return { ...state, current_partner_errors: null, current_partner_loader: true, currentPartners: [] };

    case types.GET_CURRENT_PARTNER_SUCCESS:
      return { ...state, currentPartners: action.payload, current_partner_loader: false, current_partner_errors: null };


    case types.UPDATE_ROLES_AND_PARTNERS_REQUEST:
      return {
        ...state,
        loader: true,
        updateRolesAndPartnersErrors: null,
        updateRolesAndPartnersInfo: null,
        editUserSuccess: false,
        userToEdit: action.payload
      };

    case types.UPDATE_ROLES_AND_PARTNERS_SUCCESS:
      return {
        ...state,
        updateRolesAndPartnersInfo: action.payload,
        loader: false,
        editUserSuccess: true,
      };

    case types.UPDATE_ROLES_AND_PARTNERS_FAILED:
      return {
        ...state,
        loader: false,
        updateRolesAndPartnersErrors: action.payload,
      };

    case 'RESET_USER_TO_UPDATE':
      return { ...state, userToEdit: null };

    case 'RESET_UPDATE_USER_SUCCESS':
      return { ...state, editUserSuccess: false, UserToEdit: null };

    case 'SET_USER_TO_UPDATE':
      return { ...state, userToEdit: action.payload };

    case 'RESET_UPDATE_COUNTRY_ERROR':
      return { ...state, updateRolesAndPartnersErrors: null };

    case types.DELETE_USER_REQUEST:
      return { ...state, loader: true, deleteUserErrors: null, deleteUserSuccess: null, userToDelete: action.payload, hardDeleteUserLoader: true, hardDeleteUserSuccess: false, hardDeleteUserError: null }

    case types.DELETE_USER_FAILED:
      return { ...state, loader: false, deleteUserErrors: action.payload, deleteUserSuccess: null, hardDeleteUserLoader: false }

    case types.DELETE_USER_SUCCESS:
      return { ...state, loader: false, deleteUserErrors: null, deleteUserSuccess: action.payload, hardDeleteUserLoader: false, hardDeleteUserSuccess: true }

    case 'RESET_DELETE_USER_SUCCESS':
      return { ...state, hardDeleteUserSuccess: false };

    case 'GET_USER_REQUEST':
      return { ...state, loader: true, error: null, user: null }

    case 'GET_USER_FAILED':
      return { ...state, loader: false, error: action.payload, user: null }

    case 'GET_USER_SUCCESS':
      return { ...state, loader: false, error: null, user: action.payload }

    // Uses its own loader: the page-wide `loader` unmounts the whole Partner Users page.
    case types.RESET_USER_PASSWORD_REQUEST:
      return { ...state, resetPasswordLoader: true, resetPasswordErrors: null, resetPasswordSuccess: null };

    case types.RESET_USER_PASSWORD_SUCCESS:
      return { ...state, resetPasswordLoader: false, resetPasswordSuccess: action.payload };

    case types.RESET_USER_PASSWORD_FAILED:
      return { ...state, resetPasswordLoader: false, resetPasswordErrors: action.payload };

    case types.RESET_USER_PASSWORD_CLEAR:
      return { ...state, resetPasswordLoader: false, resetPasswordErrors: null, resetPasswordSuccess: null };

    case types.DISABLE_USER_FAILURE:
      return { ...state, disableUserLoader: false, disableUserErrors: action.payload };

    case types.USER_LOGOUT:
      return initialState;
    case types.RESET_USER_CONTAINER:
      return {
        ...state, loader: false, registrationError: null,
        roles_errors: null,
        error: null,
        updateRolesAndPartnersErrors: null,
        resetPasswordErrors: null,
        updateRolesAndPartnersInfo: null,
        userCreated: null,
        deleteUserErrors: null,
        deleteUserSuccess: null,
        resetPasswordSuccess: null,
      }

    case types.GET_DISABLED_USERS_REQUEST:
      return { ...state, error: null, loader: true, disabledUsers: [] };

    case types.GET_DISABLED_USERS_SUCCESS:
      return { ...state, disabledUsers: action.payload.users, disabledUsersHasNextPage: action.payload.hasNextPage, loader: false };

    case types.GET_DISABLED_USERS_FAILURE:
      return { ...state, loader: false, error: action.payload };

    case 'SET_USER_TO_VIEW_AUTH_ACTIVITIES':
      return { ...state, userToViewAuthActivities: action.payload };

    case 'CLOSE_USER_AUTH_ACTIVITIES_DIALOG':
      return { ...state, userToViewAuthActivities: null, userAuthActivities: null };

    case types.GET_USER_AUTH_ACTIVITIES_REQUEST:
      return { ...state, userAuthActivitiesLoader: true, userAuthActivitiesError: null, userAuthActivities: null, userAuthActivitiesSuccess: false };

    case types.GET_USER_AUTH_ACTIVITIES_SUCCESS:
      return { ...state, userAuthActivitiesLoader: false,  userAuthActivities: action.payload, userAuthActivitiesSuccess: true };

    case types.GET_USER_AUTH_ACTIVITIES_FAILURE:
      return { ...state, userAuthActivitiesLoader: false, userAuthActivitiesError: action.payload, userAuthActivitiesSuccess: false };

    case types.GET_USERS_AUTH_ACTIVITIES_REQUEST:
      return { ...state, usersAuthActivitiesLoader: true, usersAuthActivitiesError: null, usersAuthActivities: null, usersAuthActivitiesSuccess: false };

    case types.GET_USERS_AUTH_ACTIVITIES_SUCCESS:
      return { ...state, usersAuthActivitiesLoader: false,  usersAuthActivities: action.payload, usersAuthActivitiesSuccess: true };

    case types.GET_USERS_AUTH_ACTIVITIES_FAILURE:
      return { ...state, usersAuthActivitiesLoader: false, usersAuthActivitiesError: action.payload, usersAuthActivitiesSuccess: false };
    
    default:
      return state;
  }
}
